import React, { Component, createRef } from "react";
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  CircularProgress,
  MenuItem,
  Paper,
  Box,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  IconButton,
  Container,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { apiUrl } from "../../../comp/ApiUrl";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Breadcrumb from "../../../comp/Breadcrumb";

class CadastroLoja extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imagens: [],
      nome: "",
      cnpj: "",
      store_type: "",
      tfixo: "",
      tphone: "",
      temail: "",
      rua: "",
      numero: "",
      bairro: "",
      cidade: "",
      cep: "",
      referencia: "",
      horarios: [
        { dia: "Segunda-feira", aberto: false, abertura: "", fechamento: "" },
        { dia: "Terça-feira", aberto: false, abertura: "", fechamento: "" },
        { dia: "Quarta-feira", aberto: false, abertura: "", fechamento: "" },
        { dia: "Quinta-feira", aberto: false, abertura: "", fechamento: "" },
        { dia: "Sexta-feira", aberto: false, abertura: "", fechamento: "" },
        { dia: "Sábado", aberto: false, abertura: "", fechamento: "" },
        { dia: "Domingo", aberto: false, abertura: "", fechamento: "" },
      ],
      nickname: "",
      valido: null,
      carregando: false,
    };
    this.fileInputRef = createRef();
  }

  handleExcluir = (index) => {
    this.setState((prev) => {
      const imagens = [...prev.imagens];
      imagens.splice(index, 1);
      return { imagens };
    });
  };

  handleChangeDia = (index, campo, valor) => {
    const novosHorarios = [...this.state.horarios];
    novosHorarios[index][campo] = valor;
    this.setState({ horarios: novosHorarios });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("logo", file);

    try {
      const response = await fetch(`${apiUrl}/store/logo/upload`, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + Cookies.get("auth_token"),
        },
        body: formData,
      });

      const data = await response.json();
      const preview = {
        fileName: data.fileNames[0],
        preview: URL.createObjectURL(file),
      };

      this.setState((prevState) => ({
        imagens: [...prevState.imagens, preview],
      }));
    } catch (error) {
      toast.error("Erro ao fazer upload da imagem.");
    }
    event.target.value = "";
  };

  handleCepChange = async (event) => {
    const cep = event.target.value;
    this.setState({ cep });
    const cepLimpo = cep.replace(/\D/g, "");

    if (cepLimpo.length === 8) {
      try {
        const response = await fetch(
          `https://viacep.com.br/ws/${cepLimpo}/json/`
        );
        const data = await response.json();
        if (!data.erro) {
          this.setState({
            rua: data.logradouro,
            bairro: data.bairro,
            cidade: data.localidade,
          });
        }
      } catch (error) {
        toast.error("Erro ao buscar CEP.");
      }
    }
  };

  handleCheckNickname = async () => {
    const { nickname } = this.state;
    if (!nickname) return;
    this.setState({ carregando: true });
    try {
      const response = await fetch(`${apiUrl}/verifica-nickname/${nickname}`);
      const data = await response.json();
      this.setState({ valido: data.status, carregando: false });
    } catch (err) {
      this.setState({ valido: false, carregando: false });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.state.valido) {
      toast.error("Nickname inválido!");
      return;
    }
    if (this.state.imagens.length === 0) {
      toast.error("Adicione pelo menos uma imagem (Logo).");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/cadastro/loja`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("auth_token"),
        },
        body: JSON.stringify(this.state),
      });

      if (response.status === 200) {
        toast.success("Loja cadastrada com sucesso!");
      } else {
        toast.error("Erro ao cadastrar loja!");
      }
    } catch (error) {
      toast.error("Erro na conexão.");
    }
  };

  render() {
    const { nickname, valido, carregando, imagens } = this.state;

    let endAdornment = (
      <InputAdornment position="end">
        <Typography variant="body2" sx={{ mr: 1 }}>
          .fazpedido.app
        </Typography>
        {carregando ? (
          <CircularProgress size={20} />
        ) : valido === true ? (
          <CheckCircleIcon color="success" />
        ) : valido === false ? (
          <CancelIcon color="error" />
        ) : null}
      </InputAdornment>
    );

    return (
      <Box sx={{ backgroundColor: "#f4f6f8", minHeight: "100vh", pb: 5 }}>
        <Container maxWidth="lg" sx={{ mt: 4 }}>
          <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", mb: 3 }}
            >
              Dados da Loja
            </Typography>

            {/* SEÇÃO LOGO */}
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                mb: 4,
                textAlign: "center",
                backgroundColor: "#fafafa",
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  Logo da Loja
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<PhotoCamera />}
                  onClick={() => this.fileInputRef.current.click()}
                >
                  Adicionar
                </Button>
                <input
                  type="file"
                  hidden
                  ref={this.fileInputRef}
                  onChange={this.handleImageUpload}
                />
              </Box>
              <Box display="flex" flexWrap="wrap" gap={2}>
                {imagens.length > 0 ? (
                  imagens.map((img, index) => (
                    <Box key={index} sx={{ position: "relative" }}>
                      <img
                        src={img.preview}
                        alt="Preview"
                        style={{
                          width: 120,
                          height: 120,
                          borderRadius: 8,
                          objectFit: "cover",
                          border: "1px solid #ddd",
                        }}
                      />
                      <IconButton
                        size="small"
                        color="error"
                        sx={{
                          position: "absolute",
                          top: -10,
                          right: -10,
                          backgroundColor: "#fff",
                          "&:hover": { backgroundColor: "#fee" },
                        }}
                        onClick={() => this.handleExcluir(index)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))
                ) : (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ width: "100%", py: 2 }}
                  >
                    Nenhuma imagem enviada
                  </Typography>
                )}
              </Box>
            </Paper>

            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <TextField
                  label="CNPJ"
                  name="cnpj"
                  fullWidth
                  value={this.state.cnpj}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Nome da Loja"
                  name="nome"
                  fullWidth
                  value={this.state.nome}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  select
                  label="Tipo de Loja"
                  name="store_type"
                  fullWidth
                  value={this.state.store_type}
                  onChange={this.handleChange}
                >
                  <MenuItem value="1">Lanchonete / Fast-Food</MenuItem>
                  <MenuItem value="3">Restaurante / Marmitaria</MenuItem>
                  <MenuItem value="4">Pizzaria / Esfiharia</MenuItem>
                  <MenuItem value="2">Loja / Varejo Geral</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Domínio"
                  name="nickname"
                  fullWidth
                  value={nickname}
                  onChange={this.handleChange}
                  onBlur={this.handleCheckNickname}
                  InputProps={{ endAdornment }}
                />
              </Grid>

              {/* CONTATO */}
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Informações de Contato
                </Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Telefone Fixo"
                  name="tfixo"
                  fullWidth
                  value={this.state.tfixo}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Telefone Celular"
                  name="tphone"
                  fullWidth
                  value={this.state.tphone}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="E-mail"
                  name="temail"
                  fullWidth
                  value={this.state.temail}
                  onChange={this.handleChange}
                />
              </Grid>

              {/* HORÁRIOS */}
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Horário de Funcionamento
                </Typography>
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableRow>
                        <TableCell>Dia</TableCell>
                        <TableCell align="center">Abre</TableCell>
                        <TableCell>Abertura</TableCell>
                        <TableCell>Fechamento</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.horarios.map((h, index) => (
                        <TableRow key={h.dia}>
                          <TableCell>{h.dia}</TableCell>
                          <TableCell align="center">
                            <Checkbox
                              checked={h.aberto}
                              onChange={(e) => {
                                const isOpen = e.target.checked;
                                this.handleChangeDia(index, "aberto", isOpen);
                                if (!isOpen) {
                                  this.handleChangeDia(index, "abertura", "");
                                  this.handleChangeDia(index, "fechamento", "");
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <input
                              type="time"
                              style={{
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                width: "100%",
                              }}
                              value={h.abertura}
                              disabled={!h.aberto}
                              onChange={(e) =>
                                this.handleChangeDia(
                                  index,
                                  "abertura",
                                  e.target.value
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <input
                              type="time"
                              style={{
                                padding: "8px",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                width: "100%",
                              }}
                              value={h.fechamento}
                              disabled={!h.aberto}
                              onChange={(e) =>
                                this.handleChangeDia(
                                  index,
                                  "fechamento",
                                  e.target.value
                                )
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              {/* ENDEREÇO */}
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Endereço
                </Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="CEP"
                  name="cep"
                  fullWidth
                  value={this.state.cep}
                  onChange={this.handleCepChange}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  label="Rua"
                  name="rua"
                  fullWidth
                  value={this.state.rua}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="N°"
                  name="numero"
                  fullWidth
                  value={this.state.numero}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Bairro"
                  name="bairro"
                  fullWidth
                  value={this.state.bairro}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Cidade"
                  name="cidade"
                  fullWidth
                  value={this.state.cidade}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Referência"
                  name="referencia"
                  fullWidth
                  value={this.state.referencia}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
              <Button
                variant="contained"
                size="large"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={this.handleSubmit}
                sx={{ px: 4 }}
              >
                Salvar Loja
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    );
  }
}

export default CadastroLoja;
